module.exports = __webpack_public_path__ + "static/img/lady-doctor.c3048f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lady-doctor.png
// module id = 5YF4
// module chunks = 7